import SecureLS from 'secure-ls'

const secureLocalStorage = new SecureLS({
  encodingType: 'aes',
  encryptionSecret: 'k0m3rc3s3cr3t$@1',
})

export default secureLocalStorage
